import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import { useAssetCopierContext } from '../providers/AssetCopierProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssetCopierPanelFooter(props) {
  const {
    currentStep,
    goToNextStep,
    setCurrentStep,
    selectedTargetHub,
    copyableAssets
  } = useAssetCopierContext();
  const {
    onClickDone
  } = props;
  const nextButtonDisabled = !selectedTargetHub;
  if (currentStep === 'AWAITING_ACTION') {
    return null;
  }
  if (currentStep === 'CHOOSE_DESTINATION') {
    return /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        children: [/*#__PURE__*/_jsx(UIBox, {
          grow: 1
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          disabled: nextButtonDisabled,
          onClick: goToNextStep,
          "data-test-id": "asset-copier-panel-next-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-multi-account-asset-copier.next"
          })
        })]
      })
    });
  }
  if (currentStep === 'VALIDATION') {
    return null;
  }
  if (currentStep === 'CONFIRM_SELECTION') {
    return /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        children: [/*#__PURE__*/_jsx(UIBox, {
          grow: 1,
          children: /*#__PURE__*/_jsx(UIButton, {
            use: "secondary",
            onClick: () => {
              setCurrentStep('CHOOSE_DESTINATION');
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ui-multi-account-asset-copier.back"
            })
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: goToNextStep,
          disabled: copyableAssets.length === 0,
          "data-test-id": "asset-copier-panel-confirm-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-multi-account-asset-copier.confirm"
          })
        })]
      })
    });
  }
  if (currentStep === 'SUCCESS' || currentStep === 'ERROR') {
    return /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        children: [/*#__PURE__*/_jsx(UIBox, {
          grow: 1
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: onClickDone,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-multi-account-asset-copier.done"
          })
        })]
      })
    });
  }
}
export default AssetCopierPanelFooter;